/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1ChecklistChecklistidItemsId202,
  DeleteApiV1ChecklistChecklistidItemsId401,
  DeleteApiV1ChecklistChecklistidItemsId404,
  DeleteApiV1ChecklistChecklistidItemsId500,
  DeleteApiV1ChecklistChecklistidItemsIdMutationResponse,
  DeleteApiV1ChecklistChecklistidItemsIdPathParams,
} from "../../types/checkListItensController/DeleteApiV1ChecklistChecklistidItemsId.ts";

export const deleteApiV1ChecklistChecklistidItemsIdPathParamsSchema = z.object({
  checkListId: z.coerce.number().int(),
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1ChecklistChecklistidItemsIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1ChecklistChecklistidItemsId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1ChecklistChecklistidItemsId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1ChecklistChecklistidItemsId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1ChecklistChecklistidItemsId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1ChecklistChecklistidItemsId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1ChecklistChecklistidItemsId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1ChecklistChecklistidItemsId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1ChecklistChecklistidItemsId500>;

export const deleteApiV1ChecklistChecklistidItemsIdMutationResponseSchema =
  z.lazy(
    () => deleteApiV1ChecklistChecklistidItemsId202Schema,
  ) as unknown as ToZod<DeleteApiV1ChecklistChecklistidItemsIdMutationResponse>;
